module.exports = __webpack_public_path__ + "img/about-advantage3.01d81b70.png";